import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  margin-top: 32px;\n\n  ul {\n    display: flex;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CategoryFilterSectionView } from "@/components/Categories/Menu/CategoryFilterSectionView";
import { CategoryProductListView } from "@/components/Categories/Menu/CategoryProductListView";
import { useCategoryFilterHandler } from "@/hooks/useCategoryFilterHandler";
import { useMobileFilterSideSheet } from "@/hooks/useMobileFilterSideSheet";
import theme from "@/themes/uiLibraryTheme";
import { Pagination } from "@bookips/solvook-ui-library";
import { Typography, styled } from "@mui/material";
import { useMemo } from "react";
import { PreviewDialogProvider } from "../../Search/PreviewDialogProvider";
export const CategoryList = (param)=>{
    let { items =[] , totalCount =0 , filterItems =[] , sortItems =[] , isLoadingListItem , categoryName , limit , currentPage , totalPage , onChangePage  } = param;
    const { palette  } = theme;
    const { selectedFilterList , selectedSort , filterQueryHandler , isCheckFilterItem , isCheckFilterCount  } = useCategoryFilterHandler();
    const hasFilterItems = useMemo(()=>{
        return filterItems.some((filter)=>filter.items.length > 0);
    }, [
        filterItems
    ]);
    const { mobileFilterSideSheet , handleMobileSideSheet  } = useMobileFilterSideSheet();
    return /*#__PURE__*/ _jsx(PreviewDialogProvider, {
        children: /*#__PURE__*/ _jsxs(CategoryListViewContainer, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    component: "h5",
                    typography: "h5",
                    color: palette.text["title"],
                    style: {
                        textAlign: "left",
                        width: "100%"
                    },
                    children: categoryName
                }),
                /*#__PURE__*/ _jsx(CategoryFilterSectionView, {
                    filterItems: filterItems,
                    hasFilterItems: hasFilterItems,
                    handleMobileSlider: handleMobileSideSheet,
                    selectedFilterList: selectedFilterList,
                    filterQueryHandler: filterQueryHandler,
                    totalCount: totalCount,
                    sortItems: sortItems,
                    selectedSort: selectedSort,
                    isCheckFilterItem: isCheckFilterItem,
                    isCheckFilterCount: isCheckFilterCount,
                    mobileFilterSideSheet: mobileFilterSideSheet
                }),
                /*#__PURE__*/ _jsx(CategoryProductListView, {
                    isLoadingListItem: isLoadingListItem,
                    items: items,
                    limit: limit
                }),
                /*#__PURE__*/ _jsx(PaginationContainer, {
                    children: /*#__PURE__*/ _jsx(Pagination, {
                        page: currentPage,
                        onChange: (event, page)=>onChangePage(page),
                        count: totalPage,
                        size: "medium"
                    })
                })
            ]
        })
    });
};
const CategoryListViewContainer = styled("div")(_templateObject());
const PaginationContainer = styled("div")(_templateObject1());
